import {Injectable} from "@angular/core";
import {IMetaData} from "../api/data-model";

@Injectable()
export class UtilitiesService {

    constructor() {
    }

    public static rowStripe(index): "red" | "white" {
        return (index === 0 || (index % 2) === 0) ? "red" : "white";
    }

    public static stripTrailingSlash(value: string): string {
        return value ? value.replace(/\/+$/, "") : "";
    }

    public static newQuestionID(referenceStory: string, questionNum: number) {
        return referenceStory + "-" + "q" + "-" + questionNum;
    }

    public static newUuid(): string {
        // found on stack overflow, so it must be good
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
            // tslint:disable-next-line:no-bitwise
            let r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public static cacheBuster(prefix:string):string {
        return prefix + "jcb=" + Math.floor(Math.random() * 10000000);
    }

    public static convertPunctuationToASCII(text:string): string {
        text = text.replace(/[‘’]/g, "'");
        text = text.replace(/[”“]/g, '"');
        text = text.replace(/[…]/g, "...");
        text = text.replace(/[—]/g, "--");
        text = text.replace(/[–]/g, "-");

        return text;
    }

    public static convertWordOrPhraseToID(text:string): string {
        text = text.toLowerCase().split(/\s+/).join("_") + "-";
        return text;
    }

    public static getTranslationId(baseId: string, language: string): string {
        return baseId + "-" + language;
    }

    public static replaceHyphensWithEmDash(text:string): string {

        text = text.replace(/\s*--\s*/g, "—");
        return text;
    }

    public static convertNonASCIIToASCII(text:string): string {
        text = UtilitiesService.convertPunctuationToASCII(text);
        text = text.replace(/[Áá]/g, "a");
        text = text.replace(/[Éé]/g, "e");
        text = text.replace(/[Íí]/g, "i");
        text = text.replace(/[Óó]/g, "o");
        text = text.replace(/[Úú]/g, "u");
        text = text.replace(/[Üü]/g, "u");
        text = text.replace(/[Ññ]/g, "n");
        text = text.replace(/[Ëë]/g, "e");

        return text;
    }

    public static getTextCharacteristics(text:string): string {

        let characteristics:string[] = [];
        if (text.match(/[-]/)) {
            characteristics.push("HYPHENATION");
        }
        if (text.match(/[0-9]/)) {
            characteristics.push("NUMBERS");
        }
        if (text.match(/[.]/)) {
            characteristics.push("POSSIBLE ABBREVIATION");
        }
        if (text.match(/[,?"!;:)(]/)) {
            characteristics.push("PUNCTUATION");
        }
        return characteristics.join(",");
    }

    // Change straight quotes to curly and double hyphens to em-dashes.
    public static smarten(text: string): string {
        if (!text) {
            return text;
        }
        text = text.replace(/(^|[-\u2014\s(["])'/g, "$1\u2018");       // opening singles
        text = text.replace(/'/g, "\u2019");                            // closing singles & apostrophes
        text = text.replace(/(^|[-\u2014/[(\u2018\s])"/g, "$1\u201c"); // opening doubles
        text = text.replace(/"/g, "\u201d");                            // closing doubles
        text = text.replace(/--/g, "\u2014");                           // em-dashes
        return text;
    }

    public static determineATOSLevel(metaData: IMetaData): number {
        // In the metadata ATOS grade equivalent is represented as a string, optionally with a "*" at the end
        // The string actually represents grade.month, but month is the month of the school year 0 through 9 so
        // conversion to a number for averaging, sorting, etc pretty much works.
        if (!metaData) {
            return 0;
        }
        if (metaData.ATOSGradeEquivalent === "NP") {
            return parseFloat(metaData.poetryLevel.ATOSGradeEquivalent.replace("*", ""));
        } else {
            return parseFloat(metaData.ATOSGradeEquivalent.replace("*", ""));
        }
    }

    public static downloadFile(newData: string, outputName: string): void {
        let blob = new Blob([newData], {type: "text/plain"});
        // tslint:disable-next-line:no-string-literal
        let url = (window.URL || window["webkitURL"]).createObjectURL(blob);
        let link = window.document.createElement("a");
        link.href = url;
        link.download = outputName;
        alert("click ok to download next file");
        link.click();
    }

    public static getVersion(): string {
        // This regex grabs the version from the URL, the first path after the IP
        return window.location.pathname.replace(/^\/([^\/]*).*$/, "$1");
    }

    public static getPath(): string {
        // This regex grabs the path (route) from the URL
        console.log(window.location.pathname);
        return window.location.pathname.replace(/^\/[^\/]*(.*)$/, "$1");
        // return window.location.pathname;
    }

    public static getReleaseStage(): string {
        // For bugsnag logging; inferred from URL
        const host = window.location.host;
        if (host.includes(".qa.") || host.startsWith("qa.")) {
            return "qa";
        }
        if (host.includes(".ld.") || host.startsWith("ld.")) {
            return "ld";
        }
        if (host.includes(".dev.") || host.startsWith("dev.") || UtilitiesService.getVersion() === "dev") {
            return "development";
        }
        return "production";
    }

    public static parseDate(date: string): string {
        let dateArr = date.split("/");
        let year = dateArr[2].substr(2, 3);
        return dateArr[0] + "/" + dateArr[1] + "/" + year;
    }

}
